import onExitHandler from 'root/src/client/logic/form/handlers/onExitHandler'

export default (moduleId, moduleKey, onBlur, onExit, dispatcher) => (e) => {
	if (onBlur) {
		e.preventDefault()
		const { value } = e.target
		onBlur(moduleId, moduleKey, value)
	}
	onExitHandler(onExit, dispatcher, e)
}
